(function () {
  var root = document.querySelector('[data-product-root]');
  if (!root) return;
  var dataEl = document.getElementById('ProductVariants');
  var variants = [];
  try {
    variants = dataEl ? JSON.parse(dataEl.textContent) : [];
  } catch (error) {
    variants = [];
  }
  if (!variants.length) return;

  var select = root.querySelector('[data-variant-select]');
  var optionUi = root.querySelector('[data-option-ui]');
  var priceCurrent = root.querySelector('[data-price-current]');
  var availability = root.querySelector('[data-availability]');
  var sku = root.querySelector('[data-sku]');
  var barcode = root.querySelector('[data-barcode]');
  var weight = root.querySelector('[data-weight]');
  var qty = root.querySelector('[data-quantity]');
  var qtyError = root.querySelector('[data-qty-error]');
  var addButtons = root.querySelectorAll('[data-add-button]');
  var sticky = document.querySelector('[data-sticky-atc]');
  var stickyPrice = sticky ? sticky.querySelector('[data-sticky-price]') : null;
  var mainImage = root.querySelector('[data-gallery-image]');
  var status = root.querySelector('[data-gallery-status]');
  var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-gallery-thumb]'));
  var schemaEl = document.getElementById('ProductSchema');

  if (optionUi && select) {
    select.classList.add('visually-hidden');
    select.tabIndex = -1;
    select.setAttribute('aria-hidden', 'true');
    optionUi.hidden = false;
    optionUi.querySelectorAll('input').forEach(function (input) {
      input.disabled = false;
    });
  }

  function selectedOptions() {
    var selected = {};
    if (!optionUi) return selected;
    optionUi.querySelectorAll('input:checked').forEach(function (input) {
      selected[input.getAttribute('data-option-position')] = input.value;
    });
    return selected;
  }

  function findVariant() {
    if (!optionUi) {
      return variants.find(function (variant) {
        return String(variant.id) === String(select && select.value);
      }) || variants[0];
    }
    var selected = selectedOptions();
    return variants.find(function (variant) {
      return ['1', '2', '3'].every(function (position) {
        if (!Object.prototype.hasOwnProperty.call(selected, position)) return true;
        return variant['option' + position] === selected[position];
      });
    }) || null;
  }

  function updateSchema(variant) {
    if (!schemaEl) return;
    try {
      var data = JSON.parse(schemaEl.textContent);
      var offer = Array.isArray(data.offers) ? data.offers[0] : data.offers;
      if (!offer) return;
      offer.price = variant.schemaPrice;
      offer.availability = variant.available ? 'https://schema.org/InStock' : 'https://schema.org/OutOfStock';
      if (variant.absoluteUrl) offer.url = variant.absoluteUrl;
      if (variant.sku) data.sku = variant.sku;
      else delete data.sku;
      if (variant.barcode && /^[0-9]{8}$|^[0-9]{12}$|^[0-9]{13}$|^[0-9]{14}$/.test(variant.barcode)) data.gtin = variant.barcode;
      else delete data.gtin;
      schemaEl.textContent = JSON.stringify(data);
    } catch (error) {
      /* keep the server-rendered schema */
    }
  }

  function showImage(index) {
    if (!thumbs.length || !mainImage) return;
    var next = thumbs[index];
    if (!next) return;
    mainImage.src = next.getAttribute('data-full') || mainImage.src;
    mainImage.srcset = next.getAttribute('data-srcset') || '';
    mainImage.alt = next.getAttribute('data-alt') || mainImage.alt;
    thumbs.forEach(function (thumb, thumbIndex) {
      thumb.setAttribute('aria-current', thumbIndex === index ? 'true' : 'false');
    });
    if (status) status.textContent = next.getAttribute('data-status') || '';
    var prev = root.querySelector('[data-gallery-prev]');
    var nextButton = root.querySelector('[data-gallery-next]');
    if (prev) prev.disabled = index === 0;
    if (nextButton) nextButton.disabled = index === thumbs.length - 1;
  }

  function applyVariant(variant) {
    var strings = (window.EbuyTheme && window.EbuyTheme.strings) || {};
    if (select && variant) select.value = String(variant.id);
    if (!variant) {
      if (availability) availability.textContent = strings.variantUnavailable || 'That option combination is not available.';
      addButtons.forEach(function (button) {
        button.disabled = true;
        button.setAttribute('data-force-disabled', 'true');
      });
      return;
    }
    if (priceCurrent) priceCurrent.textContent = variant.priceFormatted || '';
    if (stickyPrice) stickyPrice.textContent = variant.priceFormatted || '';
    if (availability) {
      if (!variant.available) availability.textContent = strings.soldOut || 'Sold out';
      else if (variant.showQuantity) availability.textContent = (strings.availableCount || '__COUNT__ available').replace('__COUNT__', String(variant.inventoryQuantity)).replace('{{ count }}', String(variant.inventoryQuantity));
      else availability.textContent = strings.inStock || 'In stock';
    }
    if (sku) {
      sku.hidden = !variant.sku;
      sku.textContent = variant.sku ? ((strings.sku || 'SKU') + ': ' + variant.sku) : '';
    }
    if (barcode) {
      barcode.hidden = !variant.barcode;
      barcode.textContent = variant.barcode ? ((strings.identifier || 'Product identifier') + ': ' + variant.barcode) : '';
    }
    if (weight) {
      weight.hidden = !variant.weightLabel;
      weight.textContent = variant.weightLabel ? ((strings.weight || 'Weight') + ': ' + variant.weightLabel) : '';
    }
    if (qty) {
      qty.max = variant.maxQuantity ? String(variant.maxQuantity) : '';
      if (variant.maxQuantity && Number(qty.value) > variant.maxQuantity) qty.value = String(variant.maxQuantity);
    }
    addButtons.forEach(function (button) {
      button.disabled = !variant.available;
      if (variant.available) button.removeAttribute('data-force-disabled');
      else button.setAttribute('data-force-disabled', 'true');
      var label = button.querySelector('[data-add-label]');
      if (label) label.textContent = variant.available ? (strings.addToCart || 'Add to cart') : (strings.soldOut || 'Sold out');
    });
    if (variant.image && mainImage) {
      var matched = thumbs.findIndex(function (thumb) {
        return thumb.getAttribute('data-media-id') === String(variant.mediaId);
      });
      if (matched >= 0) showImage(matched);
      else {
        mainImage.src = variant.image;
        mainImage.removeAttribute('srcset');
        if (variant.imageAlt) mainImage.alt = variant.imageAlt;
      }
    }
    if (window.history && window.history.replaceState && variant.url) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    }
    updateSchema(variant);
  }

  if (optionUi) {
    optionUi.addEventListener('change', function () {
      applyVariant(findVariant());
    });
  }
  if (select) {
    select.addEventListener('change', function () {
      var variant = variants.find(function (item) {
        return String(item.id) === String(select.value);
      });
      if (variant && optionUi) {
        ['1', '2', '3'].forEach(function (position) {
          var value = variant['option' + position];
          if (!value) return;
          var input = optionUi.querySelector('input[data-option-position="' + position + '"][value="' + CSS.escape(value) + '"]');
          if (input) input.checked = true;
        });
      }
      applyVariant(variant);
    });
  }

  var form = root.querySelector('[data-product-form]');
  if (form && qty) {
    form.addEventListener('submit', function (event) {
      var submitter = event.submitter;
      if (submitter && submitter.name && submitter.name !== 'add') return;
      var value = parseInt(qty.value, 10);
      var max = qty.max ? parseInt(qty.max, 10) : null;
      var strings = (window.EbuyTheme && window.EbuyTheme.strings) || {};
      if (!isFinite(value) || value < 1) {
        event.preventDefault();
        event.stopImmediatePropagation();
        if (qtyError) {
          qtyError.hidden = false;
          qtyError.textContent = strings.quantityError || 'Enter a quantity of at least 1.';
        }
        qty.focus();
        return;
      }
      if (max && value > max) {
        event.preventDefault();
        event.stopImmediatePropagation();
        if (qtyError) {
          qtyError.hidden = false;
          qtyError.textContent = (strings.maxQty || 'Only __COUNT__ are available.').replace('__COUNT__', String(max)).replace('{{ count }}', String(max));
        }
        qty.focus();
        return;
      }
      if (qtyError) qtyError.hidden = true;
    }, true);
  }

  thumbs.forEach(function (thumb, index) {
    thumb.addEventListener('click', function () {
      showImage(index);
    });
  });
  var prev = root.querySelector('[data-gallery-prev]');
  var next = root.querySelector('[data-gallery-next]');
  function currentIndex() {
    var active = thumbs.findIndex(function (thumb) {
      return thumb.getAttribute('aria-current') === 'true';
    });
    return active < 0 ? 0 : active;
  }
  if (prev) prev.addEventListener('click', function () { showImage(currentIndex() - 1); });
  if (next) next.addEventListener('click', function () { showImage(currentIndex() + 1); });
  var gallery = root.querySelector('[data-gallery]');
  if (gallery) {
    gallery.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowRight') showImage(currentIndex() + 1);
      if (event.key === 'ArrowLeft') showImage(currentIndex() - 1);
    });
  }

  var mainAdd = root.querySelector('[data-main-add]');
  if (sticky && mainAdd && 'IntersectionObserver' in window && window.matchMedia('(max-width: 749px)').matches) {
    var observer = new IntersectionObserver(function (entries) {
      var visible = entries[0] && entries[0].isIntersecting;
      sticky.hidden = visible;
      if (visible) sticky.setAttribute('inert', '');
      else sticky.removeAttribute('inert');
    });
    observer.observe(mainAdd);
  }

  if (!customElements.get('product-recommendations')) {
    customElements.define('product-recommendations', class extends HTMLElement {
      connectedCallback() {
        var url = this.dataset.url;
        if (!url) return;
        fetch(url)
          .then(function (response) { return response.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var next = doc.querySelector('product-recommendations');
            if (next && next.innerHTML.trim()) this.innerHTML = next.innerHTML;
          }.bind(this))
          .catch(function () {});
      }
    });
  }
})();
